/*
Defines jspsych objects for correct and incorrect practice trial feeback.
*/

import jsPsychAudioMultiResponse from "@jspsych-contrib/plugin-audio-multi-response";
import { mediaAssets } from "../../..";
import i18next from "i18next";
import "../../../i18n/i18n";
import store from "store2"; //storing session data

export const endTrial = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    /* if(store.session.get("timeForceOut")){
      return mediaAssets.audio.gameEndTimeout;
    }
    else{*/
    return mediaAssets.audio.gameEnd;
    //}
  },
  prompt: () => {
    /*if(store.session.get("timeForceOut")){
      return `
        <div class="text-block">
          <h3> ${i18next.t("gameBreak.endScreenTimeout.text1")} </h3>
          <p> ${i18next.t("gameBreak.endScreenTimeout.text2")} </p>
        </div>
        <div class="key-button"> ${i18next.t('gameBreak.endScreenTimeout.text3')} </div>
      `

    }else{*/
    return `
        <div class="tiger-gif-container">
          <div class="speechbubble">
          <h1 class="header">${i18next.t("gameBreak.endScreen.text1")} </h1>
          <p class="text"> ${i18next.t("gameBreak.endScreen.text2")} </p>
          </div>
          <img class="roam-tiger" src=${
            mediaAssets.images[store.session.get("displayImage")]
          } alt="tiger"/>
        </div>
        <div class="key-button"> ${i18next.t(
          "gameBreak.endScreen.text3",
        )} </div>`;

    //}
  },
  on_load: () => {
    document.getElementById("jspsych-progressbar-container").style.visibility =
      "hidden";
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
};
